import { useCallback, useEffect, useState } from "react";
import { t } from "i18next";
import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import { api } from "../../../../../../services/api/api";
import OdooFieldMappingListItem from "./OdooFieldMappingListItem";

export default function AdminOdooCustomersTab() {
  const [mappings, setMappings] = useState<EasyTech.Odoo.FieldMapping[] | null>(null);

  const TABLE_HEAD = [
    { label: t("admin:odoo.table.parameter", "Paramètre EasyTech"), orderKey: null },
    { label: t("admin:odoo.table.odooField", "Champ Odoo"), orderKey: null },
    { label: t("admin:odoo.table.type", "Type"), orderKey: null },
    { label: t("admin:odoo.table.description", "Description"), orderKey: null },
    { label: t("admin:odoo.table.actions", "Actions"), orderKey: null }
  ];

  const loadMappings = useCallback(() => {
    api.get("admin/odoo/mappings?entityType=CUSTOMER")
      .then((ret) => {
        setMappings((ret as EasyTech.Odoo.FieldMapping[]) || []);
      })
      .catch((err) => {
        console.error(err);
        setMappings([]);
      });
  }, []);

  useEffect(() => {
    loadMappings();
  }, [loadMappings]);

  return (
    <div className="admin-odoo-tab">
      <div className="mb-4">
        <p className="text-sm text-gray-600">
          {t("admin:odoo.customers.description", "Configurez la correspondance des champs du client avec le modèle res.partner dans Odoo.")}
        </p>
      </div>

      <div className="my-4">
        {mappings ? (
          <Table
            tableHead={TABLE_HEAD}
            emptyTable={mappings.length === 0 ? t("admin:odoo.empty", "Aucun champ configuré") : false}
          >
            {mappings.map((mapping, index) => (
              <OdooFieldMappingListItem
                key={mapping.id}
                mapping={mapping}
                isLast={index === mappings.length - 1}
                onChange={loadMappings}
              />
            ))}
          </Table>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}
